import { render, staticRenderFns } from "./FeaturedItem.vue?vue&type=template&id=546ae05c&scoped=true&"
import script from "./FeaturedItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedItem.vue?vue&type=style&index=0&id=546ae05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ae05c",
  null
  
)

export default component.exports